import React, { FC } from 'react';
import Widget from 'shared/components/Widget';
import { colors } from 'styles/colors';
import { PaperProps } from '@mui/material';

interface ICardWrapper extends PaperProps {}

const CardWrapper: FC<ICardWrapper> = ({ children, id, sx, ...props }) => {
  return (
    <Widget
      id={id}
      sx={{
        border: `0.0625rem solid ${colors.border.disabledGray}`,
        borderRadius: ({ typography }) => typography.pxToRem(16),
        minHeight: '13rem',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Widget>
  );
};

export default CardWrapper;
